import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { getCollabMissions, setCollabMissions } from "../../components/teams/teamsSlice";
import { use } from "react";
import moment from "moment";
import { Localize } from "../../app/lang/langs";


export default function MissionHistoryModal(props) {
    let visible = props.visible;
    let setVisible = props.setVisible;
    let collabId = props.collabId;

    const dispatch = useDispatch();

    const missionHistory = useSelector((state) => state.teams.collabMissions);
    const [missionHistoryFlat, setMissionHistoryFlat] = useState([]);

    useEffect(() => {
        if (missionHistory) {
            setMissionHistoryFlat([
                ...(missionHistory.upcomingMissions || []),
                ...(missionHistory.ongoingMissions || []),
                ...(missionHistory.pastMissions || [])
            ]);
        }
    }, [missionHistory]);


    useEffect(() => {
        if (visible) {
            // Fetch mission history data based on collabId
            // This could be a Redux action or an API call
            // For example: dispatch(fetchMissionHistory(collabId));
            dispatch(getCollabMissions({ id_collab: collabId }));
        }
    }, [visible, collabId]);

    const dateBodyTemplate = (rowData, column) => {
        let date = moment(rowData[column.field]);
        return date.isValid() ? date.format("DD/MM/YYYY") : "N/A";
    }

    const onhide = () => {
        setVisible(false);
        setMissionHistoryFlat([]);
        dispatch(setCollabMissions([]));
    }

    return (
        <Dialog
            header="Mission History"
            visible={visible}
            onHide={() => onhide()}
            style={{
                width: "60vw",
                maxWidth: 900,
                borderRadius: '16px',
                overflow: 'hidden',
                background: 'rgba(255, 255, 255, 0.92)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                boxShadow: '0 8px 32px rgba(0, 40, 128, 0.1), 0 2px 8px rgba(255, 144, 21, 0.06)',
                border: '1px solid rgba(0, 40, 128, 0.06)'
            }}
            modal
            draggable={false}
            resizable={false}
            className="ventr-mission-history-dialog"
        >
            {missionHistoryFlat.length > 0 ? (
                <DataTable
                    value={missionHistoryFlat}
                    scrollable
                    sortMode="single"
                    globalFilter={null}
                    emptyMessage="No mission history found."
                >
                    <Column field="team_name" header="Equipe" sortable />
                    <Column field="poste_name" header="Poste" sortable />
                    <Column field="start_date" header={Localize("START_DATE")} body={dateBodyTemplate} sortable />
                    <Column field="end_date" header={Localize("END_DATE")} body={dateBodyTemplate} sortable />
                </DataTable>
            ) : (
                <p className="m-0" style={{
                    textAlign: 'center',
                    padding: '32px 16px',
                    color: '#6b7280',
                    fontWeight: 400,
                    fontSize: '0.95rem'
                }}>No mission history found.</p>
            )}
        </Dialog>
    );
}